import Cal from "@calcom/embed-react"
import { useCalendarizeUi } from "@/hooks/useCalendarizeUi"
import { CALENDARIZE_ORIGIN, CALENDARIZE_EMBED_JS_URL } from "@/utils/calendarize"

interface CalendarizeEmbedProps {
  calLink?: string
  config?: Record<string, unknown>
  onSuccess?: () => void
  emptyMessage: string
}

export default function CalendarizeEmbed({
  calLink,
  config,
  onSuccess,
  emptyMessage,
}: CalendarizeEmbedProps) {
  useCalendarizeUi(onSuccess)

  if (!calLink) {
    return (
      <div className="p-4 text-center">
        <p>{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className="h-[60vh] w-[60vw]">
      <Cal
        calLink={calLink}
        style={{ width: "100%", height: "100%", overflow: "scroll" }}
        config={{ layout: "month_view", ...config }}
        calOrigin={CALENDARIZE_ORIGIN}
        embedJsUrl={CALENDARIZE_EMBED_JS_URL}
      />
    </div>
  )
}
